





















































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { isFunction } from 'lodash';
import { GridApi } from 'ag-grid-community';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import {
  FormFieldDefMap,
  emitFormChangeEvent,
} from '@/reusable/Form/formUtils';
import moment from 'moment';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { TipoDte } from '@/pantallas/SucursalVirtual/VerFacturacion/fetchTipoDte';
import { TipoEstado } from '@/pantallas/SucursalVirtual/VerFacturacion/fetchEstados';
import { ConfigEmpresas } from '@/pantallas/SucursalVirtual/NuevaSolicitud/fetchConfigInicial';

@Component({
  components: {
    DatePicker,
    FormFieldsContainer,
  },
})
export default class FiltrosBusqueda extends Vue {
  @Prop() listaEstados: TipoEstado[];
  @Prop() listaTipoDocumentos: TipoDte[];
  @Prop() categoriaUsuario: string;
  @Prop() listaEmpresas: ConfigEmpresas[];

  formFields: FormFieldDefMap = {
    empresa: {
      label: 'Empresa',
      id: 'empresa',
      value: '',
    },
    folio: {
      label: 'Nº Documento',
      id: 'folio',
      value: '',
    },
    tipoDTE: {
      label: 'Tipo de Documento',
      id: 'tipoDTE',
      value: '',
    },
    estado: {
      label: 'Estado Pago',
      id: 'estado',
      value: '',
    },
    cantidadRegistros: {
      label: 'Cantidad Registros',
      id: 'cantidadRegistros',
      value: '',
    },
    fechaDesde: {
      label: 'Fecha Desde',
      id: 'fechaDesde',
      value: moment(this.fechaMaxima),
      format: 'DD/MM/YYYY',
    },
    fechaHasta: {
      label: 'Fecha Hasta',
      id: 'fechaHasta',
      value: moment(this.fechaMaxima),
      format: 'DD/MM/YYYY',
    },
  };

  handleBuscarClick() {
    this.$emit('resultadoBusqueda', this.formFields);
  }

  @Watch('formFields', { deep: true })
  handleFormChange(fields: FormFieldDefMap) {
    emitFormChangeEvent(this.$emit.bind(this), {
      entity: {
        fechaDesde: fields.fechaDesde.value,
        fechaHasta: fields.fechaHasta.value,
      } as any,
    });
  }

  get fechaMaxima() {
    let fechaMax: any = new Date().toISOString().substr(0, 10);
    return fechaMax;
  }

  get fechaMaximaInicio() {
    //let fechaMax: any = new Date().toISOString().substr(0, 10);
    let fechaMax = this.formFields.fechaHasta.value;
    return fechaMax as moment.Moment;
  }

  get fechaMinimaInicio() {
    //let fechaMax: any = new Date().toISOString().substr(0, 10);
    let fechaIni = this.formFields.fechaDesde.value;
    return fechaIni as moment.Moment;
  }

  get fechaMinima() {
    let fechaMin = moment(new Date())
      .add(-12, 'months')
      .toISOString()
      .substr(0, 10);
    return fechaMin;
  }

  clearFilters() {
    this.formFields.fechaDesde.value = moment(this.fechaMaxima);
    this.formFields.fechaHasta.value = moment(this.fechaMaxima);
    this.formFields.tipoDTE.value = '';
    this.formFields.folio.value = '';
    this.formFields.estado.value = '';
    this.formFields.cantidadRegistros.value = '';
    this.showAdvancedFilters = false;
    this.$emit('clear');
  }

  showFilters: boolean = true;

  showAdvancedFilters: boolean = true;
  AdvancedFilters() {
    this.showAdvancedFilters = !this.showAdvancedFilters;
  }
}
